import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Dialog, DialogActions, DialogContent, Stack, Typography } from '@mui/material'
import Input from 'common/components/form/Input'
import { BasicDialogTitle } from 'common/components/modal/DialogComponents'

const DialogCreateLot = ({
    open,
    onClose = () => {},
    onValidate = () => {},
}) => {
    const [name, setName] = useState()
    const [tickets, setTickets] = useState()
    return (
        <Dialog
            open={open}
            onClose={onClose}
        >
            <BasicDialogTitle onClose={onClose}>Créer un nouveau lot</BasicDialogTitle>
            <DialogContent>
                <Stack margin={1} spacing={1}>
                    <Typography>{'1.[nom du lot] => Lot en cours'}</Typography>
                    <Typography>{'2.[nom du lot] => Lot à venir'}</Typography>
                    <Typography>{'3.[nom du lot] => Lot fermé / archivé'}</Typography>
                </Stack>
                <Input
                    label='Nom du lot'
                    value={name}
                    onChange={setName}
                />
                <Input
                    label='Tickets existants (séparés de ,)'
                    value={tickets}
                    onChange={setTickets}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => {
                        onValidate(name, tickets)
                        onClose()
                    }}
                    variant='contained'
                    color='primary'
                >
                    Valider
                </Button>
            </DialogActions>
        </Dialog>
    )
}

DialogCreateLot.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onValidate: PropTypes.func,
}

export default DialogCreateLot